const getters = {
  firstClientHeight (state) {
    return state.clientHeight - 225 + 'px'
  },
  secondClientHeight (state) {
    return state.clientHeight - 250 + 'px'
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js